if (document.documentElement.lang.split('-')[0] === 'hu') {
if (!customElements.get('pb-routines')) customElements.define('pb-routines', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const options = {signal: this.abort.signal};
    this.track = this.querySelector('.pb-routines__track');
    this.controls = this.querySelector('.pb-routines__controls');
    if (!this.track.children.length && this.dataset.mode !== 'directory') { this.hidden = true; return; }
    if (this.dataset.mode === 'catalog') this.setupFilters(options);
    this.querySelectorAll('.pb-routine__add').forEach(button => {
      button.hidden = false;

    });
    this.addEventListener('click', event => { const button = event.target.closest('.pb-routine__add'); if (button && this.contains(button)) this.add(button); }, options);
    this.addEventListener('change', event => {
      const select=event.target.closest('[data-routine-format]');if(!select)return;
      const template=[...this.querySelectorAll('[data-routine-format-template]')].find(t=>t.dataset.routineFormatTemplate===select.value);
      const next=template?.content.firstElementChild?.cloneNode(true);if(!next)return;
      const card=select.closest('.pb-routine');card.replaceWith(next);next.querySelector('.pb-routine__add').hidden=false;
      window.PBCroAnalytics?.emit('routine_format_select',{routine_id:next.dataset.group,format:next.dataset.format,location:this.dataset.mode});
      next.querySelector('select')?.focus();this.update();
    }, options);
    this.addEventListener('click',event=>{const link=event.target.closest('a');if(!link)return;const card=link.closest('.pb-routine');window.PBCroAnalytics?.emit('routine_click',{routine_id:card?.dataset.group,location:this.dataset.mode,action:card?'product':'view_all'});},options);
    this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
      this.track.scrollBy({left: Number(button.dataset.direction) * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }, options));
    this.track.addEventListener('scroll', () => this.update(), {...options, passive: true});
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.track); this.update();
  }
  update() {
    if (['catalog','directory'].includes(this.dataset.mode)) { this.controls.hidden = true; return; }
    this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
    this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
    this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
  }
  setupFilters(options) {
    this.cards = [...this.querySelectorAll('.pb-routine')];
    this.filters = this.querySelector('.pb-routines__filters');
    this.filters.hidden = false;
    const panel = this.filters.closest('details');
    panel.hidden = false; panel.open = !matchMedia('(max-width: 600px)').matches;
    for (const key of ['need', 'range']) {
      const select = this.filters.elements[key];
      while (select.options.length > 1) select.remove(1);
      [...new Set(this.cards.map(card => card.dataset[key]))].sort((a,b) => a.localeCompare(b, 'hu')).forEach(value => select.add(new Option(value, value)));
    }
    this.filters.addEventListener('submit', event => event.preventDefault(), options);
    this.filters.addEventListener('input', () => this.filter(), options);
    this.filters.addEventListener('reset', () => requestAnimationFrame(() => this.filter()), options);
    this.filter();
  }
  filter() {
    const {need, range, budget, stock} = this.filters.elements;
    let count = 0;
    this.cards.forEach(card => {
      const match = (!need.value || card.dataset.need === need.value) && (!range.value || card.dataset.range === range.value) && (budget.value === '' || Number(card.dataset.price) <= Math.round(Number(budget.value) * 100)) && (!stock.checked || card.dataset.available === 'true');
      card.hidden = !match;
      if (match) count++;
    });
    this.querySelector('.pb-routines__results').textContent = count === 1 ? '1 találat' : `${count} találat`;
    this.querySelector('.pb-routines__empty').hidden = count !== 0;
  }
  async add(button) {
    if (this.busy || button.disabled) return;
    this.busy = true;
    const card = button.closest('.pb-routine');
    window.PBCroAnalytics?.emit('routine_click',{routine_id:card.dataset.group || card.dataset.routine,location:this.dataset.mode,action:'add'});
    const status = card.querySelector('.pb-routine__status');
    const buttons = [...this.querySelectorAll('.pb-routine__add')];
    const disabled = buttons.map(b => b.disabled);
    buttons.forEach(b => { b.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Termékek hozzáadása…';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const items = JSON.parse(card.querySelector('[data-items]').textContent);
      const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'A hozzáadást nem sikerült megerősíteni.');
      window.PBCroAnalytics?.emit('routine_add_success',{routine_id:card.dataset.group || card.dataset.routine,format:card.dataset.format,location:this.dataset.mode,items_added:items.reduce((n,i)=>n+i.quantity,0),value:(result.items || []).reduce((n,i)=>n+(i.final_line_price ?? i.price*i.quantity),0)/100});
      status.textContent = 'A rutin a kosárba került. A kosár megnyitása…';
      window.location.assign(root + 'cart');
    } catch (error) {
      window.PBCroAnalytics?.emit('routine_add_error',{routine_id:card.dataset.group || card.dataset.routine,location:this.dataset.mode});
      // Never automatically retry a cart mutation: its outcome can be uncertain.
      status.textContent = (error instanceof TypeError ? 'A kapcsolat megszakadt.' : error.message) + ' Újabb próbálkozás előtt ellenőrizd a kosár tartalmát. ';
      const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'Kosár megtekintése'; status.append(link);
      buttons.forEach((b, i) => { b.disabled = disabled[i]; });
      button.removeAttribute('aria-busy'); this.busy = false;
    }
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; this.observer?.disconnect(); }
});

} else {
if (!customElements.get('pb-routines')) customElements.define('pb-routines', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const options = {signal: this.abort.signal};
    this.track = this.querySelector('.pb-routines__track');
    this.controls = this.querySelector('.pb-routines__controls');
    if (!this.track.children.length && this.dataset.mode !== 'directory') { this.hidden = true; return; }
    if (this.dataset.mode === 'catalog') this.setupFilters(options);
    this.querySelectorAll('.pb-routine__add').forEach(button => {
      button.hidden = false;

    });
    this.addEventListener('click', event => { const button = event.target.closest('.pb-routine__add'); if (button && this.contains(button)) this.add(button); }, options);
    this.addEventListener('change', event => {
      const select=event.target.closest('[data-routine-format]');if(!select)return;
      const template=[...this.querySelectorAll('[data-routine-format-template]')].find(t=>t.dataset.routineFormatTemplate===select.value);
      const next=template?.content.firstElementChild?.cloneNode(true);if(!next)return;
      const card=select.closest('.pb-routine');card.replaceWith(next);next.querySelector('.pb-routine__add').hidden=false;
      window.PBCroAnalytics?.emit('routine_format_select',{routine_id:next.dataset.group,format:next.dataset.format,location:this.dataset.mode});
      next.querySelector('select')?.focus();this.update();
    }, options);
    this.addEventListener('click',event=>{const link=event.target.closest('a');if(!link)return;const card=link.closest('.pb-routine');window.PBCroAnalytics?.emit('routine_click',{routine_id:card?.dataset.group,location:this.dataset.mode,action:card?'product':'view_all'});},options);
    this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
      this.track.scrollBy({left: Number(button.dataset.direction) * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }, options));
    this.track.addEventListener('scroll', () => this.update(), {...options, passive: true});
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.track); this.update();
  }
  update() {
    if (['catalog','directory'].includes(this.dataset.mode)) { this.controls.hidden = true; return; }
    this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
    this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
    this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
  }
  setupFilters(options) {
    this.cards = [...this.querySelectorAll('.pb-routine')];
    this.filters = this.querySelector('.pb-routines__filters');
    this.filters.hidden = false;
    const panel = this.filters.closest('details');
    panel.hidden = false; panel.open = !matchMedia('(max-width: 600px)').matches;
    for (const key of ['need', 'range']) {
      const select = this.filters.elements[key];
      while (select.options.length > 1) select.remove(1);
      [...new Set(this.cards.map(card => card.dataset[key]))].sort((a,b) => a.localeCompare(b, 'ro')).forEach(value => select.add(new Option(value, value)));
    }
    this.filters.addEventListener('submit', event => event.preventDefault(), options);
    this.filters.addEventListener('input', () => this.filter(), options);
    this.filters.addEventListener('reset', () => requestAnimationFrame(() => this.filter()), options);
    this.filter();
  }
  filter() {
    const {need, range, budget, stock} = this.filters.elements;
    let count = 0;
    this.cards.forEach(card => {
      const match = (!need.value || card.dataset.need === need.value) && (!range.value || card.dataset.range === range.value) && (budget.value === '' || Number(card.dataset.price) <= Math.round(Number(budget.value) * 100)) && (!stock.checked || card.dataset.available === 'true');
      card.hidden = !match;
      if (match) count++;
    });
    this.querySelector('.pb-routines__results').textContent = count === 1 ? '1 rutină găsită' : `${count} rutine găsite`;
    this.querySelector('.pb-routines__empty').hidden = count !== 0;
  }
  async add(button) {
    if (this.busy || button.disabled) return;
    this.busy = true;
    const card = button.closest('.pb-routine');
    window.PBCroAnalytics?.emit('routine_click',{routine_id:card.dataset.group || card.dataset.routine,location:this.dataset.mode,action:'add'});
    const status = card.querySelector('.pb-routine__status');
    const buttons = [...this.querySelectorAll('.pb-routine__add')];
    const disabled = buttons.map(b => b.disabled);
    buttons.forEach(b => { b.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Adăugăm produsele…';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const items = JSON.parse(card.querySelector('[data-items]').textContent);
      const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Adăugarea nu a putut fi confirmată.');
      window.PBCroAnalytics?.emit('routine_add_success',{routine_id:card.dataset.group || card.dataset.routine,format:card.dataset.format,location:this.dataset.mode,items_added:items.reduce((n,i)=>n+i.quantity,0),value:(result.items || []).reduce((n,i)=>n+(i.final_line_price ?? i.price*i.quantity),0)/100});
      status.textContent = 'Rutina a fost adăugată. Deschidem coșul…';
      window.location.assign(root + 'cart');
    } catch (error) {
      window.PBCroAnalytics?.emit('routine_add_error',{routine_id:card.dataset.group || card.dataset.routine,location:this.dataset.mode});
      // Never automatically retry a cart mutation: its outcome can be uncertain.
      status.textContent = (error instanceof TypeError ? 'Conexiunea a fost întreruptă.' : error.message) + ' Verifică produsele din coș înainte de o nouă încercare. ';
      const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'Vezi coșul'; status.append(link);
      buttons.forEach((b, i) => { b.disabled = disabled[i]; });
      button.removeAttribute('aria-busy'); this.busy = false;
    }
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; this.observer?.disconnect(); }
});

}
